/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * RapidWorks REST API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiV3RaptorJobsJobIdTicketsParams,
  GetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsParams,
  GetTicketResourceGroupsResultDto,
  PagedResultOfTicketDetailsDto,
  ProblemDetails,
  PutApiV3RaptorJobsJobIdTicketsTicketIdParams,
  RaptorTicketDto,
  UpdateRaptorTicketInput
} from '.././model';

import { axiosInstance } from '../../axios-instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Gets all tickets for a specific job with filtering, sorting, and pagination.
 */
export const getApiV3RaptorJobsJobIdTickets = (
  jobId: number,
  params?: GetApiV3RaptorJobsJobIdTicketsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<PagedResultOfTicketDetailsDto>(
    { url: `/api/v3/raptor-jobs/${jobId}/tickets`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiV3RaptorJobsJobIdTicketsQueryKey = (jobId?: number, params?: GetApiV3RaptorJobsJobIdTicketsParams) => {
  return [`/api/v3/raptor-jobs/${jobId}/tickets`, ...(params ? [params] : [])] as const;
};

export const getGetApiV3RaptorJobsJobIdTicketsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  params?: GetApiV3RaptorJobsJobIdTicketsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiV3RaptorJobsJobIdTicketsQueryKey(jobId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>> = ({ signal }) =>
    getApiV3RaptorJobsJobIdTickets(jobId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV3RaptorJobsJobIdTicketsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>>;
export type GetApiV3RaptorJobsJobIdTicketsQueryError = ProblemDetails | void;

export function useGetApiV3RaptorJobsJobIdTickets<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  params: undefined | GetApiV3RaptorJobsJobIdTicketsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>,
          TError,
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3RaptorJobsJobIdTickets<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  params?: GetApiV3RaptorJobsJobIdTicketsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>,
          TError,
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3RaptorJobsJobIdTickets<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  params?: GetApiV3RaptorJobsJobIdTicketsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Gets all tickets for a specific job with filtering, sorting, and pagination.
 */

export function useGetApiV3RaptorJobsJobIdTickets<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  params?: GetApiV3RaptorJobsJobIdTicketsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTickets>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV3RaptorJobsJobIdTicketsQueryOptions(jobId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets a single RaptorTicket by ID for a specific job.
Validates that the ticket belongs to the specified job.
Tries to retrieve from RaptorTicketVw first, then falls back to RaptorTicketLegacyVw if not found.
 */
export const getApiV3RaptorJobsJobIdTicketsTicketId = (
  jobId: number,
  ticketId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<RaptorTicketDto>({ url: `/api/v3/raptor-jobs/${jobId}/tickets/${ticketId}`, method: 'GET', signal }, options);
};

export const getGetApiV3RaptorJobsJobIdTicketsTicketIdQueryKey = (jobId?: number, ticketId?: number) => {
  return [`/api/v3/raptor-jobs/${jobId}/tickets/${ticketId}`] as const;
};

export const getGetApiV3RaptorJobsJobIdTicketsTicketIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  ticketId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiV3RaptorJobsJobIdTicketsTicketIdQueryKey(jobId, ticketId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>> = ({ signal }) =>
    getApiV3RaptorJobsJobIdTicketsTicketId(jobId, ticketId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(jobId && ticketId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV3RaptorJobsJobIdTicketsTicketIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>
>;
export type GetApiV3RaptorJobsJobIdTicketsTicketIdQueryError = ProblemDetails | void;

export function useGetApiV3RaptorJobsJobIdTicketsTicketId<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  ticketId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>,
          TError,
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3RaptorJobsJobIdTicketsTicketId<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  ticketId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>,
          TError,
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3RaptorJobsJobIdTicketsTicketId<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  ticketId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Gets a single RaptorTicket by ID for a specific job.
Validates that the ticket belongs to the specified job.
Tries to retrieve from RaptorTicketVw first, then falls back to RaptorTicketLegacyVw if not found.
 */

export function useGetApiV3RaptorJobsJobIdTicketsTicketId<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  ticketId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV3RaptorJobsJobIdTicketsTicketIdQueryOptions(jobId, ticketId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Updates an existing ticket for a specific job.
 */
export const putApiV3RaptorJobsJobIdTicketsTicketId = (
  jobId: number,
  ticketId: number,
  updateRaptorTicketInput: UpdateRaptorTicketInput,
  params?: PutApiV3RaptorJobsJobIdTicketsTicketIdParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<RaptorTicketDto>(
    {
      url: `/api/v3/raptor-jobs/${jobId}/tickets/${ticketId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateRaptorTicketInput,
      params
    },
    options
  );
};

export const getPutApiV3RaptorJobsJobIdTicketsTicketIdMutationOptions = <TError = ProblemDetails | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiV3RaptorJobsJobIdTicketsTicketId>>,
    TError,
    { jobId: number; ticketId: number; data: UpdateRaptorTicketInput; params?: PutApiV3RaptorJobsJobIdTicketsTicketIdParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiV3RaptorJobsJobIdTicketsTicketId>>,
  TError,
  { jobId: number; ticketId: number; data: UpdateRaptorTicketInput; params?: PutApiV3RaptorJobsJobIdTicketsTicketIdParams },
  TContext
> => {
  const mutationKey = ['putApiV3RaptorJobsJobIdTicketsTicketId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiV3RaptorJobsJobIdTicketsTicketId>>,
    { jobId: number; ticketId: number; data: UpdateRaptorTicketInput; params?: PutApiV3RaptorJobsJobIdTicketsTicketIdParams }
  > = (props) => {
    const { jobId, ticketId, data, params } = props ?? {};

    return putApiV3RaptorJobsJobIdTicketsTicketId(jobId, ticketId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiV3RaptorJobsJobIdTicketsTicketIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiV3RaptorJobsJobIdTicketsTicketId>>
>;
export type PutApiV3RaptorJobsJobIdTicketsTicketIdMutationBody = UpdateRaptorTicketInput;
export type PutApiV3RaptorJobsJobIdTicketsTicketIdMutationError = ProblemDetails | void;

/**
 * @summary Updates an existing ticket for a specific job.
 */
export const usePutApiV3RaptorJobsJobIdTicketsTicketId = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiV3RaptorJobsJobIdTicketsTicketId>>,
      TError,
      { jobId: number; ticketId: number; data: UpdateRaptorTicketInput; params?: PutApiV3RaptorJobsJobIdTicketsTicketIdParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiV3RaptorJobsJobIdTicketsTicketId>>,
  TError,
  { jobId: number; ticketId: number; data: UpdateRaptorTicketInput; params?: PutApiV3RaptorJobsJobIdTicketsTicketIdParams },
  TContext
> => {
  const mutationOptions = getPutApiV3RaptorJobsJobIdTicketsTicketIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Gets resource groups for a specific ticket.
 */
export const getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups = (
  jobId: number,
  ticketId: number,
  params?: GetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<GetTicketResourceGroupsResultDto>(
    { url: `/api/v3/raptor-jobs/${jobId}/tickets/${ticketId}/resource-groups`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsQueryKey = (
  jobId?: number,
  ticketId?: number,
  params?: GetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsParams
) => {
  return [`/api/v3/raptor-jobs/${jobId}/tickets/${ticketId}/resource-groups`, ...(params ? [params] : [])] as const;
};

export const getGetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  ticketId: number,
  params?: GetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsQueryKey(jobId, ticketId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>> = ({ signal }) =>
    getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups(jobId, ticketId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(jobId && ticketId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>
>;
export type GetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsQueryError = ProblemDetails | void;

export function useGetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  ticketId: number,
  params: undefined | GetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>,
          TError,
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  ticketId: number,
  params?: GetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>,
          TError,
          Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  ticketId: number,
  params?: GetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Gets resource groups for a specific ticket.
 */

export function useGetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups<
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>,
  TError = ProblemDetails | void
>(
  jobId: number,
  ticketId: number,
  params?: GetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsJobIdTicketsTicketIdResourceGroups>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV3RaptorJobsJobIdTicketsTicketIdResourceGroupsQueryOptions(jobId, ticketId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
